<template>
  <div class="px-2 pb-8">
    <div class="absolute right-[5px] top-[20px] z-10 lg:right-[-20px]">
      <!-- <svg class="text-[color:var(--color-secondary)-500]" height="85" width="92">
        <use href="/static/images/related-product-label.svg#main" />
      </svg> -->

      <!-- <div
        class="absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] -rotate-[20deg] text-center text-lg font-bold leading-[20px]"
      >
        Groene keuze
      </div> -->
      <img v-if="customLabel" :src="customLabel" alt="customlabel" height="85" width="92" />
    </div>

    <div class="rounded-[36px] bg-white px-8 py-3 shadow-xl">
      <!-- Product image -->
      <router-link :to="link" @click="$emit('link-click', $event)">
        <div class="relative h-full min-h-[275px]">
          <VcImage
            :src="image"
            :alt="product.name"
            size-suffix="md"
            class="absolute top-0 size-full object-contain object-center"
            lazy
          />
        </div>
      </router-link>

      <div>
        <!-- Product title -->
        <router-link
          :to="link"
          :title="product.name"
          class="mt-2 line-clamp-3 min-h-[85px] text-xl font-bold"
          @click="$emit('link-click', $event)"
        >
          {{ product.name }}
        </router-link>
        <!-- Product price -->
        <div class="mt-2 text-lg">
          {{ product.brandName }}
        </div>
        <img v-if="energyLabelImage" :src="energyLabelImage" alt="Energy label" class="mb-2 w-12" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getProductRoute } from "@/core/utilities";
import { ProductUtils } from "../../utils";
import type { Product } from "@/core/api/graphql/types";
import type { RouteLocationRaw } from "vue-router";

defineEmits<{ (eventName: "link-click", globalEvent: PointerEvent): void }>();

const props = defineProps<{
  product: Product;
}>();

const { getProductCustomLabel, getProductEneryLabelImage } = ProductUtils();

const link = computed<RouteLocationRaw>(() => getProductRoute(props.product.id, props.product.slug));
const energyLabelImage = computed(() => getProductEneryLabelImage(props.product));
const customLabel = computed(() => getProductCustomLabel(props.product));

const image = computed(() => props.product?.imgSrc || props.product?.images[0].url);
</script>
